<template>
    <div class="home-model">
        <div class="home-model-box">
            <p class="home-model-title">
                海量车型供您选择
            </p>

            <ul class="home-model-ul">
                <li class="home-model-li"
                    :class="liNum == index ? 'home-model-li-ac' : ''"
                    v-for="(item,index) in liList"
                    :key="index"
                    @click="liClick(index)"
                >
                    {{ item.text }}
                </li>
            </ul>

            <div class="home-model-area">
                <div class="home-model-left"
                     v-for="(item, index) in carList.slice(0,1)"
                >
                    <div class="model-left-img">
                        <el-image
                                :src="item.pic"
                                fit="cover"></el-image>
                        <!--<img :src="item.pic" alt="">-->
                    </div>
                    <div class="model-left-bot">
                        <span class="car-name">{{ item.brand }}</span> | <span class="car-seat">{{ item.seat }}</span>座
                    </div>
                </div>
                <div class="home-model-middle">
                    <div class="model-middle-top"
                         v-for="(itm, idx) in carList.slice(1,2)"
                    >
                        <div class="middle-top-img">
                            <el-image
                                    :src="itm.pic"
                                    fit="cover"></el-image>
                            <!--<img :src="itm.pic" alt="">-->
                        </div>
                        <div class="middle-top-bot">
                            <span class="car-name">{{ itm.brand }}</span> | <span class="car-seat">{{ itm.seat }}</span>座
                        </div>
                    </div>

                    <div class="model-middle-bot">
                        <div class="model-middle-bot-box"
                             v-for="(list, xbIndex) in carList.slice(2,4)"
                        >
                            <div class="middle-bot-box-img">
                                <el-image
                                        :src="list.pic"
                                        fit="cover"></el-image>
                                <!--<img :src="list.pic" alt="">-->
                            </div>
                            <div class="middle-bot-box-bot">
                                <span class="car-name">{{ list.brand }}</span> | <span class="car-seat">{{ list.seat }}</span>座
                            </div>
                        </div>
                    </div>
                </div>
                <div class="home-model-right"
                     v-for="(car, carIndex) in carList.slice(4,5)"
                >
                    <div class="model-right-img">
                        <el-image
                                :src="car.pic"
                                fit="cover"></el-image>
                        <!--<img :src="car.pic" alt="">-->
                    </div>
                    <div class="model-right-bot">
                        <span class="car-name">{{ car.brand }}</span> | <span class="car-seat">{{ car.seat }}</span>座
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "homeModel",
        props: {
            carList: {
                type: Array,
                default: [],
            }
        },
        data() {
            return {
                liNum: 2,
                liList: [
                    {
                        text: '7-20座'
                    },
                    {
                        text: '20-40座'
                    },
                    {
                        text: '40-59座'
                    }
                ],

                /*carList: [
                    {
                        carImg: require('@/assets/images/index/carImg.png'),
                        carName: '丰田考斯特',
                        carSeat: 7,
                    },
                    {
                        carImg: require('@/assets/images/index/carImg.png'),
                        carName: '丰田考斯特',
                        carSeat: 8,
                    },
                    {
                        carImg: require('@/assets/images/index/carImg.png'),
                        carName: '丰田考斯特',
                        carSeat: 9,
                    },
                    {
                        carImg: require('@/assets/images/index/carImg.png'),
                        carName: '丰田考斯特',
                        carSeat: 10,
                    },
                    {
                        carImg: require('@/assets/images/index/carImg.png'),
                        carName: '丰田考斯特',
                        carSeat: 11,
                    }
                ]*/
            }
        },
        methods: {
            liClick(num) {
                this.liNum = num;
                this.$emit('carTypeChange',this.liNum);
            }
        }
    }
</script>

<style scoped>
    .home-model {
        width: 100%;
        min-width: 1200px;
    }

    .home-model-box {
        width: 1200px;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        padding-top: 70px;
    }

    .home-model-title {
        width: 500px;
        height: 38px;
        line-height: 38px;
        text-align: center;
        color: #333;
        font-size: 32px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        margin: 0 auto;
    }

    .home-model-ul {
        width: 600px;
        height: 24px;
        line-height: 24px;
        margin: 20px auto 0;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
    }

    .home-model-li {
        width: 98px;
        height: 20px;
        line-height: 20px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666;
        text-align: center;
        border-left: 1px solid #666;
        cursor: pointer;
    }

    .home-model-li:nth-child(1) {
        border-left: none;
    }

    .home-model-li-ac {
        color: #FA592A;
    }

    .home-model-area {
        width: 1200px;
        margin: 44px auto 0;
        display: flex;
        flex-direction: row;
    }

    .home-model-left {
        width: 454px;
        height: 366px;
        border-radius: 4px;
        margin-right: 10px;
        position: relative;
        cursor: pointer;
    }

    .model-left-img {
        width: 454px;
        height: 366px;
    }

    .model-left-img img {
        width: 100%;
        height: 100%;
        border-radius: 4px;
    }

    .model-left-img .el-image {
        width: 100%;
        height: 100%;
        border-radius: 4px;
    }

    .model-left-bot {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        width: 454px;
        height: 36px;
        line-height: 36px;
        background: rgba(0, 0, 0, 0.6);
        border-radius: 0px 0px 4px 4px;
        z-index: 2;
        display: flex;
        flex-direction: row;
        align-items: center;

        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #FFFFFF;
    }

    .model-left-bot span {
    }

    .car-name {
        margin-left: 20px;
        margin-right: 5px;
    }

    .car-seat {
        margin-left: 5px;
    }

    .home-model-middle {
        width: 470px;
        height: 366px;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        margin-right: 10px;
    }

    .model-middle-top {
        width: 470px;
        height: 180px;
        border-radius: 4px;
        position: relative;
        cursor: pointer;
    }

    .middle-top-img {
        width: 470px;
        height: 180px;
    }

    .middle-top-img img {
        width: 100%;
        height: 100%;
        border-radius: 4px;
    }

    .middle-top-img .el-image {
        width: 100%;
        height: 100%;
        border-radius: 4px;
    }

    .middle-top-bot {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        width: 470px;
        height: 36px;
        line-height: 36px;
        background: rgba(0, 0, 0, 0.6);
        border-radius: 0px 0px 4px 4px;
        z-index: 2;
        display: flex;
        flex-direction: row;
        align-items: center;

        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #FFFFFF;
    }

    .middle-top-bot span {

    }

    .model-middle-bot {
        width: 470px;
        height: 180px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-top: 4px;
    }

    .model-middle-bot-box {
        width: 230px;
        height: 180px;
        border-radius: 4px;
        position: relative;
        cursor: pointer;
    }

    .middle-bot-box-img {
        width: 230px;
        height: 180px;
        border-radius: 4px;
    }

    .middle-bot-box-img img {
        width: 100%;
        height: 100%;
        border-radius: 4px;
    }

    .middle-bot-box-img .el-image {
        width: 100%;
        height: 100%;
        border-radius: 4px;
    }

    .middle-bot-box-bot {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        width: 230px;
        height: 36px;
        line-height: 36px;
        background: rgba(0, 0, 0, 0.6);
        border-radius: 0px 0px 4px 4px;

        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #FFFFFF;
    }

    .middle-bot-box-bot span {
    }

    .home-model-right {
        width: 256px;
        height: 366px;
        border-radius: 4px;
        position: relative;
        cursor: pointer;
    }

    .model-right-img {
        width: 256px;
        height: 366px;
        border-radius: 4px;
    }

    .model-right-img img {
        width: 100%;
        height: 100%;
    }

    .model-right-img .el-image {
        width: 100%;
        height: 100%;
    }

    .model-right-bot {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        width: 256px;
        height: 36px;
        line-height: 36px;
        background: rgba(0, 0, 0, 0.6);
        border-radius: 0px 0px 4px 4px;

        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #FFFFFF;
    }

    .model-right-bot span {
    }
</style>


// WEBPACK FOOTER //
// src/pages/home/components/homeModel.vue